import { DatePipe as NgDatePipe } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATETIME_FORMAT,
  DEFAULT_DATETIME_SIMPLE_FORMAT,
} from '../constants/app.constants';

@Pipe({
  name: 'csDate',
  standalone: true,
})
export class DatePipe implements PipeTransform {
  private _locale = inject(LOCALE_ID);
  private _datePipe = inject(NgDatePipe);

  transform(value: string, time = false, simple = true) {
    if (!value) return null;

    return this._datePipe.transform(
      value,
      time ? (simple ? DEFAULT_DATETIME_SIMPLE_FORMAT : DEFAULT_DATETIME_FORMAT) : DEFAULT_DATE_FORMAT,
      this._locale
    );
  }
}
